import { Environment } from "./environment.type";

// Integration
export const environment : Environment = {
    production: true,
    useMocks: false,
    apiBaseUrl: '',
    qsapp : {
        url: `${import.meta.env.NG_APP_URL}`,
        version: `${import.meta.env.NG_APP_VERSION}`,
        buildVersion: `${import.meta.env.NG_APP_BUILD_VERSION}`
    },
    msalConfig: {
        clientId: `${import.meta.env.NG_APP_CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${import.meta.env.NG_APP_TENANT_ID}`,
        redirect: `${import.meta.env.NG_APP_REDIRECT_URL}`
    },
    apiScopes: {
        'profile': {
            scopes: [ 'openid', 'email', 'profile', 'user.read' ],
            uri: 'https://graph.microsoft.com/v1.0/me'
        },
        'backend': {
          scopes: [ `${import.meta.env.NG_APP_BACKEND_SCOPE}` ],
          uri: `${import.meta.env.NG_APP_BACKEND_URL}/*`
        }
    }
};
